import React from "react";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const ArchiveSkeleton: React.FC = () => (
  <div className="mb-5 divide-y divide-base-light-grey border-b border-grey-light md:rounded-xl md:border">
    <div className="flex items-center gap-3 px-6 py-4 text-lg font-medium md:text-base">
      <Skeleton variant="circular" className="h-[52px] w-[52px]" />
      <Skeleton className="w-[300px] text-lg" />
    </div>
    <div className="divide-y divide-base-light-grey">
      <div className="flex items-center px-4 py-3 md:px-6 md:py-4">
        <div className="h-5 w-5" />
        <Skeleton className="w-20 px-2" />
      </div>
      <div>
        <div className="hidden grid-cols-[repeat(4,2fr)1fr] gap-2 border-y border-grey-light bg-base-light-grey px-6 py-3 text-grey-dark md:grid">
          <Skeleton className="w-20 text-xs" />
          <Skeleton className="w-20 text-xs" />
          <Skeleton className="w-20 text-xs" />
          <Skeleton className="w-20 text-xs" />
          <Skeleton className="w-20 justify-self-end text-xs" />
        </div>
        <div className="divide-y divide-base-light-grey">
          {Array(12)
            .fill(0)
            .map((_, index) => (
              <React.Fragment key={index}>
                <div className="flex h-[4.5rem] items-center gap-3 px-4 py-3 md:hidden">
                  <Skeleton variant="circular" className="h-8 w-8" />
                  <div className="w-full">
                    <div className="mb-1 flex justify-between ">
                      <Skeleton className="w-20 text-sm" />
                      <Skeleton className="w-16 text-sm" />
                    </div>
                    <div className="flex justify-between">
                      <Skeleton className="w-32 text-sm" />
                    </div>
                  </div>
                </div>
                <div className="hidden w-full grid-cols-[repeat(4,2fr)1fr] items-center gap-2 whitespace-nowrap px-6 py-4 md:grid">
                  <div className="flex items-center gap-2">
                    <Skeleton variant="circular" className="h-8 w-8" />
                    <Skeleton className="w-20 text-sm" />
                  </div>
                  <Skeleton className="w-16 text-sm" />
                  <Skeleton className="w-24 text-sm" />
                  <Skeleton variant="rounded" className="h-5 w-20 text-sm" />
                  <div className="flex justify-end gap-4">
                    <Skeleton variant="circular" className="h-5 w-5" />
                    <Skeleton variant="circular" className="h-5 w-5" />
                  </div>
                </div>
              </React.Fragment>
            ))}
        </div>
      </div>
    </div>
  </div>
);
